"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMediaLeft;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIMediaLeft(props) {
  var className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-media__item', 'private-media__item--left', className)
  }));
}

UIMediaLeft.displayName = 'UIMediaLeft';
UIMediaLeft.propTypes = {
  children: _propTypes.default.node
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/layout/UIMediaLeft.js
// module id = 751
// module chunks = 209 210 211 212